import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";

export * from "./types";

const ENDPOINTS = {
  EVENT_STREAM: "/api/v2/org/:organization_id/user/:user_id/event-stream",
};

/** Negotiated subprotocol; must match zensei-api websocketUpgrader.Subprotocols. */
export const EVENT_STREAM_WS_PROTOCOL = "zensei.event-stream.v1";

const WS_BEARER_SUBPROTOCOL_PREFIX = "bearer.";

/**
 * Opens the org user event stream. Browsers cannot set Authorization on the
 * upgrade request, so the JWT is sent in Sec-WebSocket-Protocol instead of the URL.
 */
export function createEventStreamWebSocket(
  url: string,
  accessToken: string,
): WebSocket {
  return new WebSocket(url, [
    EVENT_STREAM_WS_PROTOCOL,
    `${WS_BEARER_SUBPROTOCOL_PREFIX}${accessToken}`,
  ]);
}

export class EventStreamAPI {
  constructor(private client: CohesiveAPIClient) {}

  async getEventStreamUrl(): Promise<string> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    return (
      this.client.axios.defaults.baseURL?.replace(/^http/, "ws") +
      route(ENDPOINTS.EVENT_STREAM, {
        organization_id: organizationId,
        user_id: userId,
      })
    );
  }
}
